/* eslint-disable camelcase */
export default {
	cert_email_audit: '证书密钥邮件提交审批',
	wait_merchant_no: '待操作商户号',
	wait_merchant_full_name: '待操作供应商门户名称',
	email_applicant: '密钥邮件收件人(申请人)',
	email_cc: '密钥邮件抄送人',
	dev_doc_tip: '开发接口指引文档（请查阅产品功能所需证书密钥后再进行申请)',
	dev_doc_audit_tip: '开发接口指引文档(请查询产品类型所需证书密钥后再进行审批)',
	apply_content: '申请内容',
	please_select_apply_content: '请选择申请内容',
	key_version: '密钥版本',
	apply_version_2: '申请APIV2密钥',
	apply_version_3: '申请APIV3密钥',
	api_version_2: 'APIV2密钥',
	api_version_3: 'APIV3密钥',
	apply_range: '使用范围',
	please_input_apply_range: '请输入使用范围',
	apply_range_tip_1:
		'*该证书密钥仅适用于描述中的使用范围，不可通过其他任何方式使用和向外传播数据；若违反使用和传播导致的一切后果，由申请人本人负责！',
	apply_status: '申请单状态',
	apply_use_range: '证书秘钥申请使用范围',
	review_approval: '审核/审批',
	review_approval_history: '审核/审批历史',
	review_approval_comment: '审核/审批意见',
	please_input: '请输入内容',
	current_reviewer: '当前审批人',
	current_node: '当前节点',
	handler: '处理人',
	result: '处理结果',
	step: '处理步骤',
	opinion: '意见',
	processing_time: '处理时间',
	time_consuming: '耗时',
	current_merchant: '当前商户号',
	current_merchant_full_name: '当前供应商门户名称',
	wait: '待',
	cert_serial_no: '证书序列号',
	cert_pwd: '证书密码',
	wait_upload_cert: '证书文件',
	wait_upload_cert_tip_1: 'apiclient_cert.p12',
	certificate: '证书',
	merchant_cert_apply_number_placeholder: '请输入商户号,可以输入以逗号分割的多个商户号：xxx,yyy',
	bizSystem: '业务系统名称/编码',
	bussiness_system: '业务系统',
	bizSystem_tip: '独特及唯一的识别业务系统的名称或编码即可(4-100个字符)',
	bizSystem_placeholder: '示例：供应商门户平台/gmmp',
	bizContactPerson: '业务联系人',
	bizContactPerson_tip: '可选择多位业务联系人',
	bizSystemUrl: '业务系统地址',
	bizSystemUrl_placeholder: '示例：gmmp-pro.woa.com',
	apply_notice_1: '微信产品能力所需证书、密钥版本指引',
	certificate_selection: '证书选择',
	apply_key_versions: '密钥版本选择',
	no_available_merchant: '没有符合条件的商户号',
	please_make_sure_admin_same: '请确保所有的商户号的超管都一致',
	apply_time: '申请时间',
	cancel_apply: '撤回申请',
	get_cert_key: '获取解密密钥',
	leader_of_applicant: '申请人Leader',
	api_pwd_register_status: 'API密钥登记状态',
	api_cert_register_status: 'API证书登记状态',
	guidelines_for_applying_for_a_merchant_api_certificate: '申请商户API证书指引',
	guidelines_for_setting_ap_iv2_keys: '设置APIv2密钥指引',
	guidelines_for_setting_ap_iv3_keys: '设置APIv3密钥指引'
};
